import messages from './translations/en.json';

export const english = {
  locale: 'en-GB',
  messages,
};
